var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import sort, { stringSort } from "@domains/utils/sort";
export var locationDetailsMapper = function (data, req) {
    var result = [];
    if (data && data.length > 0) {
        var sortedData = applySorting(req.sortRecord, data);
        result = sortedData.map(function (item, i) {
            return {
                data: __assign(__assign({}, item), { isChildOpen: false }),
                dataKids: [],
                errMsg: "",
            };
        });
    }
    return result;
};
var applySorting = function (sortRecord, data) {
    if ((sortRecord === null || sortRecord === void 0 ? void 0 : sortRecord.type) && (sortRecord === null || sortRecord === void 0 ? void 0 : sortRecord.type) === "string") {
        data = stringSort(data, sortRecord === null || sortRecord === void 0 ? void 0 : sortRecord.key, sortRecord === null || sortRecord === void 0 ? void 0 : sortRecord.order);
    }
    else {
        data = sort(data, sortRecord === null || sortRecord === void 0 ? void 0 : sortRecord.key, sortRecord === null || sortRecord === void 0 ? void 0 : sortRecord.order);
    }
    return data;
};
